window.dataLayer = window.dataLayer || [];

// To debug you can flip this flag or run the below command in the console
// localStorage.setItem("track_debug", true);
const debug = false;

/* eslint-disable */
// Push to the dataLayer, with a failsafe
export const pushTo = (obj) => {
    if (debug || localStorage.getItem("track_debug")) {
        console.group(`Track event ${obj.event}`);
        console.table(obj);
        console.groupEnd();
    }

    // Use try to prevent js issues with ad blockers
    try {
        if (window.dataLayer) {
            window.dataLayer.push(obj);
        }
    } catch (error) {
        console.warn(error);
    }
};
/* eslint-enable */

// Push GTM custom events into dataLayer
export const pushEvent = (event) => pushTo(event);

// Push google analytics events into dataLayer
export const trackEvent = (obj) => pushTo(obj);

// Note: track-event listener is handled in modules/track/index.js to avoid duplicates



const BASE_VIDEO_EVENT_OBJ = { };

export const VIDEO = {
    view: "video_loaded",
    start: "video_start",
    progress: () => "video_progress",
    error: "video_error",
    finish: "video_complete"
};

const EVENT_TYPE_BY_NAME = {
    video_start: "start",
    video_error: "error",
    video_complete: "complete",
    video_finish: "complete",
    video_load: "load",
    video_loaded: "load",
    video_view: "load",
};

function deriveEventType(eventName) {
    if (!eventName) return undefined;
    if (typeof eventName === "string" && eventName.indexOf("video_progress") === 0) return "progress";
    return EVENT_TYPE_BY_NAME[eventName];
}

export function pushVideoEvent(options) {
    pushEvent({
        ...BASE_VIDEO_EVENT_OBJ,
        ...options,
        event_type: deriveEventType(options && options.event),
    });
}
